import { render, staticRenderFns } from "./pagenation.vue?vue&type=template&id=16a07614&scoped=true"
import script from "./pagenation.vue?vue&type=script&lang=js"
export * from "./pagenation.vue?vue&type=script&lang=js"
import style0 from "./pagenation.vue?vue&type=style&index=0&id=16a07614&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a07614",
  null
  
)

export default component.exports